import {listen, validateCodingSequence} from "../utils";

const Selector = {
    CODING_SEQUENCE_FORM_START: '.coding-sequence-form #id_start',
    CODING_SEQUENCE_FORM_END: '.coding-sequence-form #id_end',
    TOGGLE_TARGET_ID: '[data-toggle-target-id]'
};


// Validate coding sequence when start changes
listen('change', Selector.CODING_SEQUENCE_FORM_START, (event, target) => {
    const endEl = target.form.querySelector(Selector.CODING_SEQUENCE_FORM_END)
    validateCodingSequence(target, endEl)
})

// Validate coding sequence when end changes
listen('change', Selector.CODING_SEQUENCE_FORM_END, (event, target) => {
    const startEl = target.form.querySelector(Selector.CODING_SEQUENCE_FORM_START)
    validateCodingSequence(startEl, target)
})

// Toggle target once when source element changes
const toggledElementList = new WeakSet()
listen('change', Selector.TOGGLE_TARGET_ID, (event, target) => {
    let el = document.getElementById(target.dataset.toggleTargetId);

    if (el && !toggledElementList.has(el)) {
        el.checked = false
        toggledElementList.add(el)
    }
})
